import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { ApplicationApi } from '../../../@core/backend/common/api/application.api';
import { ThirdPartyApplicationsApi } from '../../../@core/backend/common/api/thirdPartyApplications.api';
import { User, UserData } from '../../../@core/interfaces/common/users';
import { UserStore } from '../../../@core/stores/user.store';
import { NbDialogService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Firstpaymentdialog } from '../../student-verification/payment_dialog/paymentdialog';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ApplicationProcessApi } from '../../../@core/backend/common/api/applicationProcess.api';
import { saveAs } from 'file-saver';


@Component({
  selector: 'ngx-agent-dashboard',
  templateUrl: './agent-dashboard.component.html',
  styleUrls: ['./agent-dashboard.component.scss']
})
export class AgentDashboardComponent implements OnInit {
 
  role: any;
  user: User;  
  id:number;
  email:any;
  helpEmailId = environment.helpEmailId;
  imageUrl = environment.imageUrl
  displayvideo1: boolean;

  protected readonly unsubscribe$ = new Subject<void>();


  constructor(private api: ApplicationApi,
    private userStore: UserStore,
    private agentapi: ThirdPartyApplicationsApi,
    private toastrService: NbToastrService,
    private NbDialogService: NbDialogService,
    private usersService: UserData,
    private router: Router,
    private fb: FormBuilder,
    private applicationProcessApi : ApplicationProcessApi) { 
      this.usersService.getCurrentUser().pipe(takeUntil(this.unsubscribe$))
      .subscribe((user) => { 
        this.user = user;
        
        if(this.user.role != 'agent'){
          this.router.navigate(['pages/logout']);
        }
      })
    }

  ngOnInit(): void {
  
  }

  dashboardRoutes(){
    this.router.navigate(['pages/listAgentApplication']);
  }

  manual(){
    var pdf = this.imageUrl+ "/api/images/SU-VerificationManualStudent.pdf"
    this.applicationProcessApi.download_Manuals(pdf)
    .subscribe(data => {
      saveAs(data,'VerificationManual.pdf');
    });
 }

 videoPopup(){
  this.displayvideo1 = true;
}
}
